import {h, Fragment} from "preact"
import { useAppState, InfiniteScroll } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'

import NoResults from '../serp/NoResults'
import Products from '../serp/Products'
import Toolbar from '../serp/Toolbar'
import Sidebar from '../serp/Sidebar'
import BottomToolbar from '../serp/BottomToolbar'
import Loader from '../serp/Loader'

export default () => {
    const { response: { products }, loading, pageType } = useAppState()
    const foundProducts = products && products.total > 0
    const [categoryName, setCategoryName] = useState("")
    const [categoryDesc, setCategoryDesc] = useState("")

    useEffect(() => {
        const categoryEl = document.querySelector(".nosto_category > .category_string");
        const catName = (categoryEl)
            ? categoryEl.textContent
            : document.querySelector(".nosto_category")?.textContent?.split("\n")?.[0]
        setCategoryName(catName || '')
    }, [])



    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth < 769
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
                isMobile: window.innerWidth < 769
            });
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            {pageType === "category" && false && (
                <header class="SectionHeader ns-category-header">
                    <h1 class="SectionHeader__SubHeading Heading u-h6" style="text-transform: capitalize;">{categoryName}</h1>
                    <p>{categoryDesc}</p>
                </header>
            )}

            <div 
                class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-my-0 ns-mx-auto"
            >
                <div
                    class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0"
                    style={loading ? 'position: relative;' : ''}
                >
                    {(foundProducts) ? (
                        <>
                            <Toolbar
                                cardWidth={!windowSize?.isMobile ? "calc(((100% - (var(--ns-plp-grid-gutter) * 2)) / 3))" : "calc(((100% - (var(--ns-plp-grid-gutter))) / 2))"}
                            />
                            <InfiniteScroll>
                                <Products
                                    cardWidth={!windowSize?.isMobile ? "calc(((100% - (var(--ns-plp-grid-gutter) * 2)) / 3))" : "calc(((100% - (var(--ns-plp-grid-gutter))) / 2))"}
                                />
                            </InfiniteScroll>
                            <BottomToolbar />
                        </>
                    ) : loading ? (
                        <Loader />
                    ) : (
                        <NoResults />
                    )}
                </div>
            </div>
        </>
    )
}
